import{a as m}from"./chunk-IBACENKX.js";import{a as p}from"./chunk-A357F5TT.js";import{h as i,z as t}from"./chunk-326XWAT2.js";import{m as o}from"./chunk-HBP5N4FR.js";o();t();m();var E=()=>p({apiEndpoint:i});export{E as a};
//# sourceMappingURL=chunk-SG5RRFCJ.js.map
